import Moment from 'moment';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { config } from '../../../../common/';
import Minus from '../../Faq/Minus';
import Plus from '../../Faq/Plus';
import css from './AccordionAvailableServices.scss';

export interface AccordionAvailableServicesProps {
    elem: JSX.Element;
    content: string;
    showCount: boolean;
    readyToUse: boolean;
    usableDate: Date;
    offerCode: number;
    vehCode: number;
    isActivePlan: boolean;
    totalPlafondYearly: number;
    usedAmmount: number;
}

function AccordionAvailableServices(props: AccordionAvailableServicesProps) {
    const { t } = useTranslation();

    const [setActive, setActiveState] = useState('');
    const [setHeight, setHeightState] = useState('0px');
    const [setRotate, setRotateState] = useState(`${css.accordion__icon}`);

    const content = useRef<any>();

    function toggleAccordion() {
        setActiveState(setActive === '' ? `${css.active}` : '');
        setHeightState(
            setActive === `${css.active}` ? '0px' : `${content.current.scrollHeight}px`,
        );
        setRotateState(
            setActive === `${css.active}`
                ? `${css.accordion__icon}`
                : `${css.accordion__icon} ${css.rotate}`,
        );
    }

    return (
        <React.Fragment>
            <div className={css.main}>
                <div className={css.accordion__section}>
                    <div className={css.accordion__adjust}>
                        <p className={css.accordion__title}>{props.elem}</p>
                        {props.isActivePlan && props.offerCode > -1 && <div className={css.reqVoucher}>
                            <a href={`${config.BaseURL}/offers/${props.offerCode}/${props.vehCode}`}>{t('subscriptions:request-voucher')}</a>
                        </div>}
                        {props.showCount && <div className={css.notUsed}>
                            <text>{props.readyToUse ? t('subscriptions:service-available') : `${t('subscriptions:service-available-at')} ${Moment(props.usableDate).format('YYYY-MM-DD')}`}</text>
                        </div>}
                        <button
                            className={`${css.accordion} ${setActive}`}
                            onClick={toggleAccordion}
                        >
                            {
                                setActive === `${css.active}` && (
                                    <Minus width={18} fill={'#fff'} />
                                )}{
                                setActive === '' && (
                                    <Plus className={`${setRotate}`} width={18} fill={'#fff'} />
                                )
                            }
                        </button>
                    </div>
                    <div
                        ref={content}
                        style={{ maxHeight: `${setHeight}` }}
                        className={css.accordion__content}
                    >
                        <div
                            className={css.accordion__text}
                            dangerouslySetInnerHTML={{ __html: props.content }}
                        />
                        {props.isActivePlan && props.totalPlafondYearly > 0 && <div className={css.accordion__text} >
                            <p>
                                {`${t('subscriptions:plafondText1')}${props.usedAmmount}${t('subscriptions:plafondText2')}${props.totalPlafondYearly}${t('subscriptions:plafondText3')}`}
                            </p>
                        </div>}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default AccordionAvailableServices;
